import React, { useState, useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import CardMedia from "@mui/material/CardMedia";
import Rating from "@mui/material/Rating";
import Tooltip from "@mui/material/Tooltip";
import Divider from "@mui/material/Divider";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
import SuiBadge from "components/SuiBadge";

import { capitalCase } from "capital-case";
import NumberFormat from "react-number-format";
import { Carousel } from "antd";
import moment from "moment";
import Checkbox from "@mui/material/Checkbox";

import StyleDetailModal from "pages/de/styles/detail/components/StyleDetailModal";

import curved9 from "assets/images/upstyled/default_background.png";
import colors from "assets/theme/base/colors";

import CategoryContext from "context/category-context";
import {
  canResizeImageUrl,
  getStyleImages,
  getFileImage,
  getOnLineTechPackImages,
} from "utils/imageHelper";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import ProjectStatusTag from "components/UpStyled/ProjectStatusTag";

function ProjectCard4({
  project,
  size = "md",
  sx = {},
  detailUrl = null,
  handleSelectStyle,
  isSelected,
  noSlider = false,
}) {
  const [images, setImages] = useState([]);
  const metadata = project?.metadata ? project.metadata : {}; //project metadata
  const products = project?.products || [];

  useEffect(() => {
    let styleImages = [];
    //add style first image
    for (let i = 0; i < products.length; i++) {
      const temp = getStyleImages(products[i], false);

      styleImages.push(...temp);
    }
    //add all project reference image
    const fileList = metadata["othersFiles"] || [];
    const files = fileList.filter((f) => f?.type && f.type.includes("image"));
    if (files && files.length > 0) {
      styleImages.push(...files);
    }
    if (styleImages.length == 0) {
      styleImages = [{ url: curved9, name: "deafult_image" }];
    }
    setImages(styleImages);
  }, [products, metadata]);

  let styles = {
    cardWidth: 260,
    cardHeight: 425,
    imgHeight: 220,
    titleMinHeight: "34px",
    titleFontSize: "h6",
    textFontSize: "body1",
  };
  if (size == "sm") {
    styles = {
      cardWidth: 220,
      cardHeight: 375,
      imgHeight: 180,
      titleMinHeight: "26px",
      titleFontSize: "h6",
      textFontSize: "body1",
    };
  }

  const budgetMin = project?.quote?.budget_min;
  const budgetMax = project?.quote?.budget_max;

  const ListRow = ({ label, value, divider = false }) => {
    return (
      <SuiBox px={1}>
        <SuiBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{ width: "100%" }}
          gap={1}
        >
          <SuiTypography textTransform="capitalize" sx={{ flex: "none", minWidth: "min-content" }}>
            {label}
          </SuiTypography>
          <SuiBox>
            <Tooltip title={value}>
              <SuiTypography
                color="info"
                textTransform="capitalize"
                lineHeight="1"
                sx={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: "1",
                  WebkitBoxOrient: "vertical",
                  wordBreak: "break-all",
                }}
              >
                {value}
              </SuiTypography>
            </Tooltip>
          </SuiBox>
        </SuiBox>
        {divider ? <Divider sx={{ backgroundColor: colors.dark.main, margin: "4px 2px" }} /> : null}
      </SuiBox>
    );
  };

  const formatProjectDate = (project) => {
    let prefix = "";
    let date = "";
    if (project.status == "active") {
      prefix = "Desired end at: ";
      date = project?.quote?.desired_end_date
        ? moment(project.quote.desired_end_date).format("MM/DD/YY")
        : "N/A";
    } else if (project.status == "requested" || project.status == "init") {
      prefix = "Desired start date: ";
      date = project?.metadata?.desired_start_date
        ? moment(project.metadata.desired_start_date).format("MM/DD/YY")
        : "N/A";
    } else if (project.status == "completed") {
      prefix = "Finished at: ";
      date = project?.metadata?.completed_at
        ? moment(project.metadata.completed_at).format("MM/DD/YY")
        : "N/A";
    } else if (project.status == "canceled") {
      prefix = "Canceled at: ";
      date = project?.metadata?.canceled_at
        ? moment(project.metadata.canceled_at).format("MM/DD/YY")
        : "N/A";
    }
    if (prefix) {
      return <ListRow label={prefix} value={date} divider={true} />;
    } else {
      return (
        <SuiTypography
          variant="body1"
          textTransform="capitalize"
          color="text"
          sx={{
            width: "100%",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: "1",
            WebkitBoxOrient: "vertical",
          }}
        >
          N/A
        </SuiTypography>
      );
    }
  };

  let styleImages = [...images];
  if (noSlider) {
    styleImages = styleImages.slice(0, 1);
  }

  return (
    <Card
      sx={{
        my: 2,
        mx: 1,
        width: styles.cardWidth,
        minWidth: styles.cardWidth,
        height: styles.cardHeight,
        display: "flex",
        flexDirection: "column",
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "visible",
        borderColor: ({ borders }) => borders.borderColor,
        boxShadow: ({ boxShadows: { md } }) => md,
        ...sx,
      }}
    >
      <Carousel
        arrows={true}
        dots={false}
        prevArrow={
          <div>
            <button
              class="react-multiple-carousel__arrow react-multiple-carousel__arrow--left "
              type="button"
            ></button>
          </div>
        }
        nextArrow={
          <div>
            <button
              class="react-multiple-carousel__arrow react-multiple-carousel__arrow--right "
              type="button"
            ></button>
          </div>
        }
      >
        {styleImages.map((img) => (
          <SuiBox
            position="relative"
            sx={{ cursor: "pointer", overflow: "hidden", margin: "0 auto" }}
            onClick={handleSelectStyle ? () => handleSelectStyle(!isSelected) : null}
            borderRadius="xl"
            {...(handleSelectStyle
              ? {}
              : { component: detailUrl ? Link : "div", to: detailUrl ? detailUrl : null })}
          >
            <ImageCardWrapper data={img} height={styles.imgHeight} width={styles.cardWidth} />
          </SuiBox>
        ))}
      </Carousel>
      <SuiBox sx={{ position: "absolute", right: 10, top: 10 }}>
        <Tooltip title={project.status}>
          <ProjectStatusTag status={project.status} />
        </Tooltip>
      </SuiBox>
      <SuiBox py={1} px={1}>
        <div>
          <SuiBox display="flex" justifyContent="space-between" alignItems="top">
            <Tooltip title={project.name}>
              <SuiBox
                // onClick={detailUrl ? null : () => setDetailViewVisible(true)}
                component={detailUrl ? Link : "div"}
                to={detailUrl ? detailUrl : null}
                sx={{ cursor: "pointer" }}
              >
                <SuiTypography
                  variant={styles.titleFontSize}
                  fontWeight="medium"
                  lineHeight="1.2"
                  sx={{
                    minHeight: styles.titleMinHeight,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: "2",
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {project.name}
                </SuiTypography>
              </SuiBox>
            </Tooltip>
            {handleSelectStyle ? (
              <Checkbox onChange={handleSelectStyle} checked={isSelected} />
            ) : null}
          </SuiBox>

          {formatProjectDate(project)}

          <ListRow
            label="Budget:"
            value={
              budgetMin != budgetMax ? (
                <SuiBox display="flex" alignItems="center">
                  <NumberFormat
                    value={budgetMin}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                    renderText={(value, props) => (
                      <SuiTypography variant="body1" fontWeight="regular" color="info" {...props}>
                        {value}
                      </SuiTypography>
                    )}
                  />
                  <SuiTypography variant="body1" fontWeight="regular" color="info">
                    ~
                  </SuiTypography>
                  {budgetMax > 0 ? (
                    <NumberFormat
                      value={budgetMax}
                      displayType={"text"}
                      thousandSeparator={true}
                      prefix={"$"}
                      renderText={(value, props) => (
                        <SuiTypography variant="body1" fontWeight="regular" color="info" {...props}>
                          {value}
                        </SuiTypography>
                      )}
                    />
                  ) : null}
                </SuiBox>
              ) : (
                <NumberFormat
                  value={budgetMin}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={"$"}
                  renderText={(value, props) => (
                    <SuiTypography variant="body1" fontWeight="regular" color="info" {...props}>
                      {value}
                    </SuiTypography>
                  )}
                />
              )
            }
            divider={true}
          />
          <ListRow label="Number of Styles:" value={project?.products.length} divider={false} />
        </div>
      </SuiBox>
    </Card>
  );
}

export default ProjectCard4;
